import classnames from 'classnames';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { addClass, removeClass } from '../../utils/class';
import { Icon } from '../..';
import { canUseDOM } from '../../utils/exenv';
import CustomKeyboard from './CustomKeyboard';
import Portal from './Portal';
let customNumberKeyboard;
const IS_REACT_16 = Boolean(ReactDOM.createPortal);
function getBodyScrollTop() {
    const el = document.scrollingElement || document.documentElement;
    return el?.scrollTop || 0;
}
function setBodyScrollTop(scrollTop) {
    const el = document.scrollingElement || document.documentElement;
    el.scrollTop = scrollTop;
}
class NumberInput extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = (value) => {
            if (!('value' in this.props)) {
                this.setState({ value: value.target.value });
            }
            this.props.onChange(value);
        };
        this.onConfirm = () => {
        };
        this.addBlurListener = () => {
            document.addEventListener('click', this.doBlur, false);
        };
        this.removeBlurListener = () => {
            document.removeEventListener('click', this.doBlur, false);
        };
        this.saveRef = (el) => {
            if (IS_REACT_16 && el) {
                customNumberKeyboard = el;
            }
        };
        this.doBlur = (ev) => {
            const { value } = this.state;
            if (ev.target !== this.inputRef) {
                this.onInputBlur(value);
            }
        };
        this.unLinkInput = () => {
            if (customNumberKeyboard?.antmKeyboard &&
                customNumberKeyboard.linkedInput &&
                customNumberKeyboard.linkedInput === this) {
                customNumberKeyboard.linkedInput = null;
                if (this.props.autoAdjustHeight) {
                    this.getContainer().style.height = '0';
                }
                addClass(customNumberKeyboard.antmKeyboard, `${this.props.keyboardPrefixCls}-wrapper-hide`);
            }
            this.removeBlurListener();
        };
        this.onInputBlur = (value) => {
            const { keyboardType } = this.props;
            if (IS_REACT_16 && keyboardType === 'alert') {
                this.keyBoard = null;
            }
            const { focus } = this.state;
            if (focus) {
                this.setState({
                    focus: false,
                });
                this.props.onBlur(value);
                setTimeout(() => {
                    this.unLinkInput();
                }, 50);
            }
        };
        this.onInputFocus = () => {
            const { value } = this.state;
            this.props.onFocus(value);
            this.setState({
                focus: true,
            }, () => {
                if (customNumberKeyboard) {
                    customNumberKeyboard.linkedInput = this;
                    if (customNumberKeyboard.antmKeyboard) {
                        if (this.props.autoAdjustHeight) {
                            const keyBoardHeight = customNumberKeyboard.antmKeyboard.offsetHeight;
                            this.getContainer().style.height = `${keyBoardHeight}px`;
                            if (this.inputRef) {
                                const { bottom } = this.inputRef.getBoundingClientRect();
                                const clientHeight = window.innerHeight;
                                const distance = clientHeight - bottom;
                                if (distance < keyBoardHeight) {
                                    setBodyScrollTop(getBodyScrollTop() + keyBoardHeight - distance);
                                }
                            }
                        }
                        removeClass(customNumberKeyboard.antmKeyboard, `${this.props.keyboardPrefixCls}-wrapper-hide`);
                    }
                    customNumberKeyboard.confirmDisabled = value === '';
                    if (customNumberKeyboard.confirmKeyboardItem) {
                        if (value === '') {
                            addClass(customNumberKeyboard.confirmKeyboardItem, `${this.props.keyboardPrefixCls}-item-disabled`);
                        }
                        else {
                            removeClass(customNumberKeyboard.confirmKeyboardItem, `${this.props.keyboardPrefixCls}-item-disabled`);
                        }
                    }
                }
            });
        };
        this.onKeyboardClick = (KeyboardItemValue) => {
            const maxLength = 6;
            const { value } = this.state;
            const { onChange } = this;
            let valueAfterChange;
            if (KeyboardItemValue === 'delete') {
                valueAfterChange = value.substring(0, value.length - 1);
                onChange({ target: { value: valueAfterChange } });
            }
            else if (KeyboardItemValue === 'confirm') {
                valueAfterChange = value;
                onChange({ target: { value: valueAfterChange } });
                this.onInputBlur(value);
            }
            else if (KeyboardItemValue === 'hide') {
                valueAfterChange = value;
                this.onInputBlur(valueAfterChange);
            }
            else if (maxLength !== undefined &&
                Number(maxLength) >= 0 &&
                (value + KeyboardItemValue).length > maxLength) {
                valueAfterChange = (value + KeyboardItemValue).substr(0, maxLength);
                onChange({ target: { value: valueAfterChange } });
            }
            else {
                valueAfterChange = value + KeyboardItemValue;
                onChange({ target: { value: valueAfterChange } });
            }
            if (customNumberKeyboard) {
                customNumberKeyboard.confirmDisabled = valueAfterChange === '';
                if (customNumberKeyboard.confirmKeyboardItem) {
                    if (valueAfterChange === '') {
                        addClass(customNumberKeyboard.confirmKeyboardItem, `${this.props.keyboardPrefixCls}-item-disabled`);
                    }
                    else {
                        removeClass(customNumberKeyboard.confirmKeyboardItem, `${this.props.keyboardPrefixCls}-item-disabled`);
                    }
                }
            }
        };
        this.onFakeInputClick = () => {
            this.focus();
        };
        this.focus = () => {
            this.renderCustomKeyboard();
            this.removeBlurListener();
            const { focus } = this.state;
            if (!focus) {
                this.onInputFocus();
            }
            setTimeout(() => {
                this.addBlurListener();
            }, 50);
        };
        this.state = {
            focus: false,
            value: props.value || '',
        };
    }
    componentWillReceiveProps(nextProps) {
        if ('value' in nextProps) {
            this.setState({
                value: nextProps.value,
            });
        }
    }
    componentWillUnmount() {
        if (this.state.focus) {
            this.props.onBlur(this.state.value);
        }
        this.unLinkInput();
    }
    getComponent() {
        const { keyboardPrefixCls, disabledKeys, header, keyboardType } = this.props;
        const cofirmButton = (createElement("div", { className: `${keyboardPrefixCls}-confirm-button` },
            createElement(Icon, { "aria-hidden": "true", type: 'down', size: 'md', className: `${keyboardPrefixCls}-button-icon` })));
        return (createElement(CustomKeyboard, { ref: this.saveRef, onClick: this.onKeyboardClick, prefixCls: keyboardPrefixCls, header: header ? cofirmButton : null, disabledKeys: disabledKeys, type: keyboardType }));
    }
    getContainer() {
        const { keyboardPrefixCls } = this.props;
        let container = document.querySelector(`#${keyboardPrefixCls}-container`);
        if (!container) {
            container = document.createElement('div');
            container.setAttribute('id', `${keyboardPrefixCls}-container`);
            document.body.appendChild(container);
        }
        this.container = container;
        return this.container;
    }
    renderCustomKeyboard() {
        if (this.props.keyboardType === 'alert') {
            if (IS_REACT_16) {
                this.keyBoard = (createElement(Portal, { getContainer: () => this.getContainer() }, this.getComponent()));
            }
            else {
                customNumberKeyboard = ReactDOM.unstable_renderSubtreeIntoContainer(this, this.getComponent(), this.getContainer());
            }
        }
        else {
            this.keyBoard = this.getComponent();
        }
    }
    renderPortal() {
        if (!IS_REACT_16 || !canUseDOM) {
            return null;
        }
        if (this.props.keyboardType === 'inline') {
            setTimeout(() => {
                this.focus();
            }, 50);
            return this.keyBoard;
        }
        else {
            return this.keyBoard;
        }
    }
    render() {
        const { focus, value } = this.state;
        const { disabled } = this.props;
        const fakeInputCls = classnames(`fake-input`, {
            focus,
        });
        const fakeInputContainerCls = classnames('fake-input-container');
        const itemArr = [];
        const valueArr = value.split('');
        for (let i = 0; i < 6; i++) {
            const fakeItemTmp = i < valueArr.length ? 'fake-input-item-active' : 'fake-input-item';
            const fakeItemCls = classnames(fakeItemTmp, {
                'fake-input-item-noborder': i === 5,
                'fake-input-item-disabled': disabled,
            });
            const item = (createElement("div", { key: i, className: fakeItemCls }, valueArr[i] || ''));
            itemArr.push(item);
        }
        return (createElement("div", { className: fakeInputContainerCls },
            createElement("div", { role: "textbox", className: fakeInputCls, ref: el => (this.inputRef = el), onClick: disabled ? () => { } : this.onFakeInputClick }, itemArr),
            this.renderPortal()));
    }
}
NumberInput.defaultProps = {
    onChange: () => { },
    onFocus: () => { },
    onBlur: () => { },
    onVirtualKeyboardConfirm: () => { },
    prefixCls: 'im-input',
    keyboardPrefixCls: 'im-number-keyboard-verify-code',
    autoAdjustHeight: false,
};
export default NumberInput;
